import { useAgentsQuery } from 'hooks/useAgentsQuery'
import { Media } from 'media'
import { ComponentType } from 'react'
import { AdminsDesktop } from './admins-desktop'
import { AdminsMobile } from './admins-mobile'

export const Admins: ComponentType = () => {
  const { data } = useAgentsQuery({
    variables: { query: { team: 'admins' } },
  })

  const admins = data?.agents.data ?? []
  return (
    <>
      <Media at="xs">
        <AdminsMobile agents={admins.map(({ whatsapp, ...rest }: any) => ({ ...rest }))} />
      </Media>
      <Media greaterThan="xs">
        <AdminsDesktop agents={admins.map(({ whatsapp, ...rest }: any) => ({ ...rest }))} />
      </Media>
    </>
  )
}
